import { createLogger, PLAYER_LOG_EVENTS, logPlayerEvent } from "../helpers/logger.js";
export function loadScript(src) {
	return new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = src;
		script.async = true;
		script.onload = resolve;
		script.onerror = reject;
		document.head.appendChild(script);
	});
}

function pickRandomVideo(videos) {
	if (!videos || videos.length === 0) {
		return null;
	}
	const randomIndex = Math.floor(Math.random() * videos.length);
	return videos[randomIndex];
}

export async function loadSettings(videozoneId, customVideoSrc = null, debug = false) {
	const log = createLogger("SettingsLoader", debug);
	// const url = window.location.href;
	
	try {
		const resp = await fetch(`https://video.cleon.tv/config/settings/${videozoneId}.json`);

		if (!resp.ok) throw new Error("Settings not found");

		const settings = await resp.json();

	  logPlayerEvent(log, PLAYER_LOG_EVENTS.REVIVE_RESPONSE_RECEIVED, {
	    videozoneId,
	    status: resp.status,
	    ok: resp.ok,
	    url: resp.url,
	    hasPayload: !!settings,
	  });

		const zoneType = videozoneId.split("_")[1].replace(".json", "");
		if (zoneType === "pmp") {
		  settings.mode = "pmp";
		  settings.video = {
		    src: "https://video.cleon.tv/assets/videos/oceans.mp4",
		    type: "video/mp4",
		    poster: ""
		  };

		} else if (zoneType === "omp") {
		  settings.mode = "omp";

		  if (Array.isArray(settings.videos) && settings.videos.length > 0) {
		    const video = pickRandomVideo(settings.videos);
		    try {
		      settings.video = await resolveVideoSource(video);
		    } catch (error) {
		      log.error("Failed to resolve video source for OMP mode:", error);
		      settings.video = { src: "", type: "", poster: "" };
		    }
		  }

		} else if (zoneType === "monetized") {
		  settings.mode = "monetized";

		  const video = settings?.videos?.find(v => v.ID == customVideoSrc);
		  if (video) {
		    try {
		      const resolved = await resolveVideoSource(video);
		      settings.playlist = [resolved];
		      settings.playIndex = 0;
		      settings.video = resolved;
		    } catch (error) {
		      log.error("Failed to resolve video source for monetized mode:", error);
		      settings.video = { src: "", type: "", poster: "" };
		    }
		  }

		  log.debug("Monetized mode activated for settings:", resp.url);

      // Disable autoplay for videos with data-video attribute (click-to-play)
      if (customVideoSrc !== null) {
        settings.autoplay = false;
      }

		} else if (zoneType === "standard") {
	  settings.mode = "standard";

	  const requestedVideoId =
	    customVideoSrc !== null &&
	    customVideoSrc !== undefined &&
	    String(customVideoSrc).trim() !== ""
	      ? String(customVideoSrc).trim()
	      : null;

	  if (requestedVideoId) {
	    const video = settings?.videos?.find(
	      v => String(v.ID).trim() === requestedVideoId
	    );
	    log.debug(video);
	    if (video) {
	      try {
	        const resolved = await resolveVideoSource(video);
	        settings.playlist = [resolved];
	        settings.playIndex = 0;
	        settings.video = resolved;
	        return settings;
	      } catch (error) {
	        log.error("Failed to resolve video source for standard mode:", error);
	        settings.video = { src: "", type: "", poster: "" };
	      }
	    }
	  }

	  try {
	    settings.playlist = await buildResolvedPlaylist(settings.videos);
	    settings.playIndex = pickRandomIndex(settings.playlist.length);
	    settings.video = settings.playlist[settings.playIndex] || null;
	  } catch (error) {
	    log.error("Failed to build resolved playlist for standard mode:", error);
	    settings.playlist = [];
	    settings.playIndex = 0;
	    settings.video = { src: "", type: "", poster: "" };
	  }
	}

    // Disable autoplay for videos with data-video attribute (click-to-play)
    if (customVideoSrc !== null) {
      settings.autoplay = false;
    }

		return settings;
	} catch (error) {
		log.error("Failed to load settings:", error);
		throw error; // Re-throw to let caller handle it appropriately
	}
}

async function resolveVideoSource(video) {
  try {
    const hls = typeof video?.hls_url === "string" ? video.hls_url.trim() : "";
    const mp4 = typeof video?.SourceVideoUrl === "string" ? video.SourceVideoUrl.trim() : "";

    if (hls) {
      return {
        src: hls,
        type: "application/x-mpegURL",
        poster: video?.Image || ""
      };
    }

    if (mp4) {
      return {
        src: mp4,
        type: "video/mp4",
        poster: video?.Image || ""
      };
    }

    return {
      src: "",
      type: "",
      poster: video?.Image || ""
    };
  } catch (error) {
    // Handle any unexpected errors in video source resolution
    return {
      src: "",
      type: "",
      poster: ""
    };
  }
}

async function buildResolvedPlaylist(videos) {
  if (!Array.isArray(videos) || videos.length === 0) return [];
  
  try {
    // Use Promise.allSettled to handle potential rejections in individual promises
    const results = await Promise.allSettled(videos.map(v => resolveVideoSource(v)));
    
    // Filter out rejected promises and extract values from fulfilled ones
    return results
      .filter(result => result.status === "fulfilled")
      .map(result => result.value);
  } catch (error) {
    // This shouldn't happen with Promise.allSettled, but just in case
    return [];
  }
}

function pickRandomIndex(n) {
  return n > 0 ? Math.floor(Math.random() * n) : 0;
}